import api from '../api';
const routes = require('routes.js.erb');

const getFeatures = function({ commit }){
  return api.get(routes.api_v5_features_web_path()).then(result => commit("setFeatures", result["data"]["data"]["features"]["attributes"]));
}

export { getFeatures };
